var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.2339C22 17.9395 18.0287 22 12.1639 22C6.54098 22 2 17.5323 2 12C2 6.46774 6.54098 2 12.1639 2C14.9016 2 17.2049 2.9879 18.9795 4.61694L16.2131 7.23387C12.5943 3.79839 5.86475 6.37903 5.86475 12C5.86475 15.4879 8.69672 18.3145 12.1639 18.3145C16.1885 18.3145 17.6967 15.4758 17.9344 14.004H12.1639V10.5645H21.8402C21.9344 11.0766 22 11.5685 22 12.2339Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.33888b1fed68e6fc0682729164dce2c4.svg";
export { ForwardRef as ReactComponent };